import { render, staticRenderFns } from "./GuQianBiView.vue?vue&type=template&id=0a55cdcb&scoped=true"
import script from "./GuQianBiView.vue?vue&type=script&lang=js"
export * from "./GuQianBiView.vue?vue&type=script&lang=js"
import style0 from "./GuQianBiView.vue?vue&type=style&index=0&id=0a55cdcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55cdcb",
  null
  
)

export default component.exports